import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Typography,
} from '@material-ui/core';

import styles from './styles';

const Property = ({
  label,
  children,
  classes,
  disableGutters,
  labelVariant,
  valueVariant,
}) => (
  <div
    className={
      !disableGutters
        ? classes.container
        : classes.disableGutters
    }
  >
    <Typography
      variant={labelVariant}
      className={classes.label}
    >
      {label}
    </Typography>
    <Typography variant={valueVariant} component="div">
      {children || '-'}
    </Typography>
  </div>
);

Property.propTypes = {
  label: PropTypes.string,
  children: PropTypes.any,
  classes: PropTypes.object,
  disableGutters: PropTypes.bool,
  labelVariant: PropTypes.string,
  valueVariant: PropTypes.string,
};

Property.defaultProps = {
  label: '',
  children: null,
  classes: {},
  disableGutters: false,
  labelVariant: 'overline',
  valueVariant: 'body1',
};

export default withStyles(styles)(Property);
